import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../Pricing.module.css';

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;

const CallToAction = () => (
  <section className={styles.footcta}>
    <div className={styles.container}>
      <span className={`${styles.eyebrow} ${styles.sr}`} data-sr><span className={styles.dot} />Get started</span>
      <h2 className={styles.sr} data-sr style={{ marginTop: 18 }}>Do what you love. Leave the rest to us.</h2>
      <p className={styles.sr} data-sr>Free to start. Upgrade when you&apos;re ready.</p>
      <div className={styles.sr} data-sr>
        <Link to={`${dashboardUrl}/signup`} className={styles.btnYellow}>Create your account</Link>
      </div>
    </div>
  </section>
);

export default CallToAction;
